import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
import { Typography } from 'antd';
import {
  EpicCardsList,
  ProjectConstructorNavigationControls,
  ProjectsAddEpicForm,
  ProjectsConstructorLayout,
  useNavigateConstructorTabs,
  validateEpicsTab,
} from '@/views';
import { ProjectDto } from '@/core';
import { ErrorCard } from '@/components';
import classes from './ProjectsEpicsPage.module.scss';

export const ProjectsEpicsPage = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const projectData = useOutletContext<ProjectDto>();
  const isEpicsTabValid = validateEpicsTab(projectData);
  const { navigateToNextTab, navigateToPreviousTab } = useNavigateConstructorTabs(projectData);
  const [isErrorNotification, setIsErrorNotification] = useState(false);

  useEffect(() => {
    isEpicsTabValid && setIsErrorNotification(false);
  }, [isEpicsTabValid]);

  const navigateToEpicGroupsTab = () => {
    if (!isEpicsTabValid) {
      setIsErrorNotification(true);
      return;
    }
    navigateToNextTab();
  };

  return (
    <ProjectsConstructorLayout
      projectData={projectData}
      content={
        <>
          <Typography.Title level={3}>
            {projectData?.name}: {t('addEpics.title')}
          </Typography.Title>
          <Typography.Text type="secondary" className={classes.pageDescription}>
            {t('addEpics.pageDescription')}
          </Typography.Text>
          <ProjectsAddEpicForm projectData={projectData} />
          {(projectData.isCompleted && !isEpicsTabValid) || isErrorNotification ? (
            <ErrorCard text={t('addEpics.invalidPage')} />
          ) : null}
          {projectData?.epics?.length ? <EpicCardsList projectData={projectData} /> : null}
        </>
      }
      navigationControls={
        <ProjectConstructorNavigationControls
          navigateToPreviousTab={navigateToPreviousTab}
          navigateToNextTab={navigateToEpicGroupsTab}
        />
      }
    />
  );
};
